import React, { Component } from "react";
//// componentes reutilizables
import AuthService from '../../../services/login/auth.service';
import Titulo from "../../generico/TituloPagina";
import TecladoPin from "../../generico/TecladoPin";
import $ from "jquery";
import DatosSocio from "../../generico/DatosSocio";
import Popup from "react-popup";
import { mensajeExito } from "../../generico/MensajeSistemaToast";
import { trackPromise } from "react-promise-tracker";
import history from "../login/history";
import MensajeUsuario from "../../generico/MensajeUsuario";
import ConfigService from "../../../services/configuracion/ConfigService";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faFloppyDisk, faBroom, faCheck} from "@fortawesome/free-solid-svg-icons";
import axios from 'axios'
import { oauth } from "../../../components/generico/utils/UrlAPI";
import InactivarPinTransaccionalService from "../../../services/autogestion/InactivarPinTransaccionalService";


export default class InactivarPinTransaccional extends Component {

    constructor(props) {

        super(props);

    



        this.state = {
            pinAnterior: "",
            pinNuevo: undefined,
            pinConf: undefined,

            message: ""
        };

        this.initData();

      

    }

    

    


    componentDidMount() {
    }

    initData = () => {
        this.verificaTienePin();
    };

    verificaTienePin() {
        trackPromise(
          AuthService.verificaTienePin().then((response) => {
            var data = JSON.stringify(response.data);
            console.log("valores de pin", data)
            var jData = JSON.parse(data);
            // codigo = 0  ya tiene pin activo
            // codigo = 1  ya tiene un pin con estado solicitado
            // codigo = 2  ya tiene un pin con estado rechazado
            // codigo = 3  ya tiene un pin con estado temporal
            // codigo = 4  no tiene pin
    
            if (jData.codigo !== 0) {
                this.mostrarInputPin = false;
                this.setState({
                    message: jData.mensaje,
                });
            }

          })
        );
    }

    


    notifiPopupSolicitar = (titulo, mensaje) =>
    Popup.register({
        title: titulo,
        content: mensaje,
        buttons: {
            right: [
                {
                    text: "Aceptar",
                    className: "success",
                    action: () => {
                        this.solicitarPin();
                        AuthService.logout();
                        Popup.close();

                    },
                },
                {
                    text: "Cerrar",
                    className: "secundary",
                    action: function () {
                        Popup.close();
                    },
                }
            ],
        },
    });


    avisoSolicitar = () => {
      var titulo = "INFO";
      var mensaje = "¿Estás seguro de realizar esta operación?"
      Popup.queue(
          this.notifiPopupSolicitar(titulo, mensaje)
      );
  }

   
  solicitarPin() {
   
      trackPromise(
        InactivarPinTransaccionalService.inactivarPin().then(
          (response) => {
            // var data = JSON.stringify(response.data);
            // var jData = JSON.parse(data);
            // //console.log(jData);
            // if (jData.codigoRetorno === "0") {
            //   mensajeExito("Datos actualizados");
            //} 
          }
        )
      );
  }
 


    render() {
        //console.log("el valor es: ", this.mostrarInputPin);
  
            return (
                <div className="content-wrapper">
                    <Titulo texto="Inactivar PIN - Transferencia Interbancaria" />
                    <section className="content">
                        <form id="idFormReset">
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="card">
                                            <div className="card-header">
                                                <DatosSocio />
                                            </div>
                                            <div className="card-body">
                                            <div className="col-md-12">
         
          <br />
          <div className="row justify-content-md-center">
            <div className="col-md-8">
              <MensajeUsuario tipo="INFO"
                titulo="Importante"
                mensaje=" Esta acción inhabilitará el pin transaccional. En el caso de necesitar activarlo nuevamente deberá acercarse a la sucursal más cercana." />
              
            </div>
          </div>

          <hr />

          <div className="row float-right">
            <div className="col-md-12">
             
              
              
                  <button
                    type="button"
                    className="btn btn-cu-primary"
                    onClick={() => {
                      this.avisoSolicitar();

                    }}
                  >
                   <FontAwesomeIcon icon={faCheck}  />Confirmar
                  </button>
                

              <button
                hidden
                ref={(a) => (this.nextStep = a)}
                className="btn btn-cu-primary"
                onClick={this.props.nextStep}
              ></button>
            </div>
          </div>
        </div>
                                            </div>
                                            <div className="card-footer">
                                                <div className="row">
                                                    <div className="col-lg-8 col-md-6 col-12">
                                                    <label className="input-label-bold-obligatorio float-left">
                                                    (*) Campos Obligatorios
                                                </label>
                                                    </div>
                                                   
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </section>
                </div >
            );
         
        
    }
}